import { useKeycloak } from "@react-keycloak/web";
import { Button, Form, Select, Space } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import {
  useAssignProjectMutation,
  useGetAllCompanyQuery,
} from "../../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetAllProductQuery } from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { capitalize } from "../../../../utils/string";

const backLink = "/admin/users-roll-access/roll-access";

export default function AddAssignProduct() {
  const { user, role } = useAppSelector((state) => state.auth);
  const { keycloak } = useKeycloak();
  const isAdmin2 = keycloak?.realmAccess?.roles?.includes("admin2");
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const {
    isError: isAllCompanyError,
    error: allCompanyError,
    data: allCompanyData,
  } = useGetAllCompanyQuery({
    params: {
      company_id: role === "SUPER_ADMIN" ? undefined : user?.data?.company_id,
      page: 1,
      limit: 1000000000000,
    },
  });

  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      page: 1,
      limit: 10000000,
    },
  });

  const [
    assignProject,
    {
      isLoading: assignProjectIsLoading,
      isError: assignProjectIsError,
      error: assignProjectError,
      isSuccess: assignProjectIsSuccess,
    },
  ] = useAssignProjectMutation();

  useError(isAllCompanyError, allCompanyError, "Get all company data fail");
  useError(assignProjectIsError, assignProjectError, "Assign project fail");
  useError(isAllProductError, allProductError, "Get all product fail");

  const allProduct = getAllProduct?.data?.data;

  const onFinish = (values: any) => {
    const newData = {
      companyId: Number(values?.company_name),
      projectId: Number(values?.projectId),
    };

    const newDataCompanyAdmin = {
      companyId: Number(user?.data?.company_id),
      projectId: Number(values?.projectId),
    };

    if (isAdmin2) {
      assignProject(newDataCompanyAdmin);
    } else {
      assignProject(newData);
    }
  };

  useEffect(() => {
    if (isAdmin2) {
      form.setFieldsValue({
        company_name: user?.data?.company?.company_name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin2, user?.data?.company_id]);

  useEffect(() => {
    if (assignProjectIsSuccess) {
      toast("success", "Company product assigned successfully");
      navigate(backLink);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignProjectIsSuccess]);

  return (
    <>
      <SidebarLayout title={`Assign Product`} backLink={backLink}>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>Assign Product</CardTitle>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 pt-4 mb-5">
              <Form.Item
                label="Company Name"
                name="company_name"
                rules={[
                  { required: true, message: "Please enter a company name" },
                ]}
              >
                <Select
                  placeholder="Company Name"
                  showSearch
                  options={
                    allCompanyData?.data?.companies?.map((company: any) => ({
                      label: capitalize(company?.company_name),
                      value: company?.id,
                    })) || []
                  }
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  disabled={isAdmin2}
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item
                label="Select Product"
                name="projectId"
                rules={[{ required: true, message: "Please select product" }]}
              >
                <Select
                  placeholder="Select Product"
                  options={allProduct?.map((project: any) => ({
                    label: project?.name,
                    value: project?.id,
                  }))}
                  // onChange={(value) => setSelectedProjectId(value)}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </div>
          </CustomCard>
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to="/admin/users-roll-access/roll-access">
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={assignProjectIsLoading}
              >
                {"Assign Product"}
              </Button>
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
